<template>
  <div>
    <v-btn @click="newVehicle" color="accent" block dark class="mb-2">{{ $t("vehicleForm.newVehicleButton") }}</v-btn>
    <v-dialog v-model="newDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="editedVehicle.plates" :error-messages="translatedErrors.plates" :label="$t('vehicleForm.fields.plates.name')" />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="editedVehicle.model" :error-messages="translatedErrors.model" :label="$t('vehicleForm.fields.model.name')" />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="editedVehicle.engine_capacity"
                    :error-messages="translatedErrors.engine_capacity"
                    :label="$t('vehicleForm.fields.engineCapacity.name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="editedVehicle.type"
                    :items="vehicleTypes"
                    item-value="id"
                    :error-messages="translatedErrors.type"
                    item-text="name"
                    :label="$t('vehicleForm.fields.type.name')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                    :label="$t('vehicleForm.fields.isPrivate.name')"
                    :error-messages="translatedErrors.is_private"
                    v-model="editedVehicle.is_private"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="close">{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" color="blue darken-1" text @click="save"
            >{{ editedVehicle.id === null ? $t("global.add") : $t("global.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import vehicleTypes from "../../../staticData/VehicleTypes.js";
import objectStringTranslator from "../../../repository/translateStringsInObject";

const _ = require("lodash");

export default {
  name: "VehicleDialog",
  data: () => ({
    formTitle: "",
    editedItem: {
      id: null,
      plates: "",
      model: "",
      engine_capacity: "",
      type: null,
      is_private: false
    },
    errors: {
      id: [],
      plates: [],
      model: [],
      engine_capacity: [],
      type: [],
      is_private: []
    },
    snackbar: false
  }),

  watch: {
    modelChange: function() {
      this.serverValidation();
    },
    editedVehicle: {
      handler(val) {
        this.$store.commit("Vehicle/editVehicle", val);
        this.serverValidation();
      },
      deep: true
    }
  },

  computed: {
    translatedErrors() {
      let errors = JSON.parse(JSON.stringify(this.errors));
      errors = objectStringTranslator(errors);
      return errors;
    },
    vehicleTypes: vehicleTypes,
    newDialog: {
      get: function() {
        //this.editedVehicle;
        return this.$store.getters["Vehicle/isVehicleEditing"];
      },
      set: function() {
        this.$store.dispatch("Vehicle/cancelEdition");
      }
    },
    editedVehicle: function() {
      //this.editedItem = this.$store.getters["Vehicle/vehicleEdited"];
      return this.$store.getters["Vehicle/vehicleEdited"];
    }
    // modelChange: function() {
    //   for (let property in this.editedVehicle) this.editedVehicle[property]; //deep object watcher hack
    //   return this.editedVehicle;
    // }
  },
  methods: {
    close() {
      this.$store.dispatch("Vehicle/cancelEdition");
    },
    save() {
      if (!this.isValidModel()) {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.error.canNotSaveErrorsInForm"),
          color: "error"
        });
        return false;
      }
      this.$store.dispatch("Vehicle/saveEditedVehicle", this.editedVehicle);
    },
    newVehicle() {
      this.$store.dispatch("Vehicle/resumeOrNewVehicle");
    },
    isValidModel() {
      for (var property in this.errors) {
        if (this.errors[property].length > 0) {
          return false;
        }
      }
      return true;
    },
    serverValidation: _.debounce(function() {
      this.axios({
        url: "vehicle/validate",
        data: this.editedVehicle,
        method: "POST"
      })
        .then(resp => {
          for (let property in this.editedVehicle) {
            this.errors[property] = [];
          }
          for (let property in resp.data) {
            for (let i in resp.data[property]) {
              this.errors[property].push(resp.data[property][i]);
            }
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    }, 300)
  }
};
</script>

<style scoped></style>
